// extracted by mini-css-extract-plugin
module.exports = {"root":"EditMenuPricingPanel_root__2SN6b","form":"EditMenuPricingPanel_form__1GYPD","title":"EditMenuPricingPanel_title__3WXuw","subTitle":"EditMenuPricingPanel_subTitle__pvtjx"};